import React, { useCallback, useState, useEffect, useRef } from "react"
import { useHistory } from "react-router-dom"
import Form from "@bappweb/form"
import Panel from "@bappweb/panel"
import TextField from "@bappweb/textfield"
import Button from "@bappweb/button"
import Checkbox from "@bappweb/checkbox"
import Link from "@bappweb/link"
import Captcha from "@smpu-web/nested/form/captcha"
import FormMessage from "@smpu-web/globalmodules/form-message/index"
import Page from "@smpu-web/globalmodules/page"
import Element from "@bappweb/element"
import { RegexpTypes, required, email } from "@bappweb/utils"
import {
  useGetTokenByTckn1Mutation,
  useGetCaptchaMutation,
  useRefreshCaptchaMutation,
  useGetConfigMutation,
  useApplyMutation
} from "../../../api/services"
import "../assets/style.scss"
import "../../../../../assets/styles/style.scss"
import { cleanXss, getQueryStringValue } from "@smpu-web/utils/utils"

function MainForm() {
  const history = useHistory()

  const [formValues, setFormValues] = useState({
    nameSurname: "",
    phone: "",
    redirectLink: ""
  })

  const [captchaValues, setCaptchaValues] = useState({
    tokenSessionId: "",
    guid: "",
    captchaData: "",
    captcha: "",
    showCaptcha: false,
    captchaValidate: true
  })

  const [redirectLink, setRedirectLink] = useState("")

  const [error, setError] = useState<string | null>(null)
  const [isFetching, setIsFetching] = useState(false)
  const refForm = useRef(null)
  const [getTokenByTckn1] = useGetTokenByTckn1Mutation()

  const [getConfig] = useGetConfigMutation();
  useEffect(() => {
    setIsFetching(true)
    getConfig("TBBBilgiFormu.RedirectLink." + cleanXss(getQueryStringValue("channel", null)))
      .unwrap()
      .then((payload) => {
        if (!payload.IsError) {
          setRedirectLink(payload.configValue)
        }
      })
      .finally(() => {
        setIsFetching(false)
      })
  }, [getConfig])

  const handleNameBlur = useCallback(
    (e: React.FocusEvent<HTMLInputElement>) => {
      const { value } = e.target
      if ((value ?? "").length > 5 && value.length <= 100) {
        setIsFetching(true)
        getTokenByTckn1(value + "ABCABCABC")
          .unwrap()
          .then((payload) => {
            if (!payload.IsError) {
              setError("")
              setCaptchaValues({
                ...captchaValues,
                tokenSessionId: payload.tokenSessionId,
                guid: value + "ABCABCABC"
              })
            } else {
              setError(payload.ErrorMessage ? payload.ErrorMessage : "")
            }
          })
          .finally(() => {
            setIsFetching(false)
          })
      }
    },
    [getTokenByTckn1, captchaValues]
  )

  const handleChange = useCallback(
    (e) => {
      const name = e.target.name
      const value = e.target.value

      switch (name) {
        case "name":
          setError(null)
          setFormValues({
            ...formValues,
            nameSurname: value
          })
          setCaptchaValues({
            ...captchaValues,
            captchaData: "",
            tokenSessionId: "",
            showCaptcha: false
          })

          // @ts-ignore TODO
          // Captcha alanı temizlendiğinde validasyon hatası alıyor. O nedenle bu şekilde alanı temizliyoruz.
          refForm.current?.setValue("captcha", "")

          break
        case "phone":
          setError(null)
          setFormValues({
            ...formValues,
            phone: value
          })
          break
        case "captcha":
          setError(null)
          setCaptchaValues({
            ...captchaValues,
            captcha: value
          })
          break
        default:
          break
      }
    },
    [formValues, captchaValues]
  )

  const [getCaptcha] = useGetCaptchaMutation()
  useEffect(() => {
    if (captchaValues.captchaData === "" && captchaValues.tokenSessionId !== "") {
      setIsFetching(true)
      getCaptcha({
        guid: captchaValues.guid,
        TokenSessionId: captchaValues.tokenSessionId
      })
        .unwrap()
        .then((payload) => {
          if (!payload.IsError) {
            setCaptchaValues({
              ...captchaValues,
              captchaData: payload.captchaData,
              showCaptcha: true,
              captchaValidate: true
            })
          } else {
            setError(payload.ErrorMessage ? payload.ErrorMessage : "")
          }
        })
        .finally(() => {
          setIsFetching(false)
        })
    }
  }, [getCaptcha, captchaValues])

  const [refreshCaptcha] = useRefreshCaptchaMutation()
  const handleCaptchaRefresh = useCallback(() => {
    setIsFetching(true)
    refreshCaptcha({
      guid: captchaValues.guid,
      TokenSessionId: captchaValues.tokenSessionId
    })
      .unwrap()
      .then((payload) => {
        if (!payload.IsError) {
          setCaptchaValues({
            ...captchaValues,
            captchaData: payload.captchaData,
            captchaValidate: true
          })
        } else {
          setError(payload.ErrorMessage ? payload.ErrorMessage : "")
        }
      })
      .finally(() => {
        setIsFetching(false)
      })
  }, [captchaValues, refreshCaptcha])

  const [apply1] = useApplyMutation()
  const handleSubmit = useCallback(
    (e?: React.BaseSyntheticEvent, values?: Record<string, any>) => {
      if (values && captchaValues.captcha !== "") {
        setIsFetching(true)
        apply1({
          guid: captchaValues.guid,
          nameSurname: formValues.nameSurname,
          phone: formValues.phone,
          channel: cleanXss(getQueryStringValue("channel", null)),
          captcha: captchaValues.captcha.toUpperCase(),
          kvkk: values.checkboxKvkk,
          TokenSessionId: captchaValues.tokenSessionId
        })
          .unwrap()
          .then((payload) => {
            if (!payload.IsError) {
              setError(null)
              window.location.href = redirectLink
            } else {
              setError(payload.ErrorMessage ? payload.ErrorMessage : "")
              window.scrollTo({
                top: 0
              })
              refreshCaptcha({
                guid: captchaValues.guid,
                TokenSessionId: captchaValues.tokenSessionId
              })
                .unwrap()
                .then((payload) => {
                  if (!payload.IsError) {
                    setCaptchaValues({
                      ...captchaValues,
                      captcha: "",
                      showCaptcha: true,
                      captchaData: payload.captchaData,
                      captchaValidate: false
                    })
                  } else {
                    setError(payload.ErrorMessage ? payload.ErrorMessage : "")
                  }
                })
                .finally(() => {
                  setIsFetching(false)
                })
            }
          })
          .finally(() => {
            setIsFetching(false)
          })
      }
    },
    [captchaValues, formValues, apply1, refreshCaptcha, history, redirectLink]
  )

  return (
    <Page>
      <Form onSubmit={handleSubmit} onChange={handleChange} grid={false} ref={refForm}>
        <Panel hasFooter connected={false} loading={isFetching}>
          <FormMessage className={"form-msg-error"} error={error}></FormMessage>
          <Panel.Body>
            <TextField
              label="Adınız Soyadınız"
              type="text"
              name="name"
              maxLength={100}
              onBlur={handleNameBlur}
              value={formValues.nameSurname}
              validator={RegexpTypes.AlphaTr}
              validations={[required("Bu alan zorunludur.")]}
            />
            <TextField
              label="Cep Telefon No"
              type="text"
              name="phone"
              placeholder="5XX XXX XX XX"
              mask="999 999 99 99"
              maxLength={13}
              value={formValues.phone}
              getMaskedValue={true}
              validations={[required("Bu alan zorunludur.")]}
            />
            {captchaValues.showCaptcha && (
              <Captcha
                label="Güvenlik Kodu"
                id="captcha"
                type="text"
                name="captcha"
                placeholder="Güvenlik Kodu"
                captcha={captchaValues.captchaData}
                value={captchaValues.captcha}
                maxLength={4}
                maxRefreshCount={3}
                refreshClick={handleCaptchaRefresh}
                validations={[required("Lütfen güvenlik kodunu giriniz.")]}
                validateCaptcha={captchaValues.captchaValidate}
              />
            )}
            <div className="checkbox-group">
              <Checkbox
                name="checkboxKvkk"
                validations={[required("Lütfen onay kutusunu işaretleyiniz.")]}
                className="cb-position-fix"
                validateOnSubmit={true}
                block
              >
                <Link
                  href="//www.akbank.com/Documents/KISISELVERILERINKORUNMASI_TR.pdf"
                  text={"Kişisel Verilerin Korunması Kanunu hakkında Bilgilendirme"}
                  inline
                  target="_blank"
                />
                {" 'yi okudum."}
              </Checkbox>
            </div>
          </Panel.Body>
          <Panel.Footer>
            <Button text="Gönder" type="submit" fetching={isFetching} disabled={isFetching} />
          </Panel.Footer>
        </Panel>
      </Form>
      <Element type="p" className="form-information-text">
        <Link
          className="bapp-redirectLink"
          href={redirectLink}
          text={"Bilgilerimi girmeden devam etmek istiyorum."}
          inline
        />
      </Element>
    </Page>
  )
}

export default MainForm
